import { InputProps } from '../OdfjellInputComponent';

const CostComponent: React.FC<Partial<InputProps>> = ({ cost }: Partial<InputProps>) => {
    if (!cost) return <></>;

    return (
        <span title={'Cost'} className={'input-cost'}>
            {cost?.toFixed(0)}$
        </span>
    );
};

export default CostComponent;
